import axios from 'axios';
import { helperGetApiHeaders, helperGetApiRoute } from 'helpers/ApiHelper';

export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const FETCH_NEXT_SEARCH = 'FETCH_NEXT_SEARCH';

export const setSearchData = ({ data = [] } = {}) => ({
  type: SET_SEARCH_DATA,
  payload: data,
});

export const fetchNextSearch = async ({ accessToken, deviceId, nextUrl, filterName } = {}) => {
  const pageType = 'find';
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
  const result = await axios.get(nextUrl, headers).catch(error => console.error(error));

  return {
    type: FETCH_NEXT_SEARCH,
    payload: { data: { ...(result?.data ?? {}), filterName } },
  };
};

export const getSearch = async ({ accessToken, deviceId, query } = {}) => {
  const pageType = 'find';
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
  const fetchUrl = helperGetApiRoute(pageType);
  const fetchUrlwithQuery = `${fetchUrl}${query}`;
  const res = await axios
    .get(fetchUrlwithQuery, { ...headers })
    .catch(error => console.error(error));
  return res?.data?.results ?? [];
};
